import React from 'react';
import { Route } from 'react-router-dom';
import {
  AckerlandVerkaufenPage,
  SchweinestallVerkaufenPage,
  WaldVerkaufenPage,
  GruenlandVerkaufenPage,
  WeinbergeVerkaufenPage,
  EigenjagdVerkaufenPage,
  BauernhoefeVerkaufenPage,
  BiogasPage,
  SolarWindPage,
  ReitanlagenVerkaufenPage,
  AgrarflaechenPreisePage,
  VerkaufsprozessPage,
  WarumAgrarKapitalPage,
  LeistungenPage,
  HofstellenPage,
  RinderstallVerkaufenPage,
  HofMitFlaechenPage,
  SonderkulturenVerkaufenPage,
  OekopunkteVerkaufenPage,
  ServicesPage,
  EinzugsgebietPage
} from './lazyImports';

// ========================================
// CONTENT ROUTES
// Agrarflächen verkaufen Seiten (3000+ Wörter SEO Content)
// ========================================

const contentRoutes = [
  <Route key="ackerland-verkaufen" path="/ackerland-verkaufen" element={<AckerlandVerkaufenPage />} />,
  <Route key="acker-verkaufen" path="/acker-verkaufen" element={<AckerlandVerkaufenPage />} />,
  <Route key="wald-verkaufen" path="/wald-verkaufen" element={<WaldVerkaufenPage />} />,
  <Route key="gruenland-verkaufen" path="/gruenland-verkaufen" element={<GruenlandVerkaufenPage />} />,
  <Route key="weinberge-verkaufen" path="/weinberge-verkaufen" element={<WeinbergeVerkaufenPage />} />,
  <Route key="schweinestall-verkaufen" path="/schweinestall-verkaufen" element={<SchweinestallVerkaufenPage />} />,
  <Route key="oekopunkte-verkaufen" path="/oekopunkte-verkaufen" element={<OekopunkteVerkaufenPage />} />,


  <Route key="weinberg-verkaufen" path="/weinberg-verkaufen" element={<WeinbergeVerkaufenPage />} />,
  <Route key="eigenjagd-verkaufen" path="/eigenjagd-verkaufen" element={<EigenjagdVerkaufenPage />} />,
  <Route key="bauernhoefe-verkaufen" path="/bauernhoefe-verkaufen" element={<BauernhoefeVerkaufenPage />} />,
  <Route key="biogasanlage-verkaufen" path="/biogasanlage-verkaufen" element={<BiogasPage />} />,
  <Route key="solar-wind-verpachten" path="/solar-wind-verpachten" element={<SolarWindPage />} />,
  <Route key="hofstellen-verkaufen" path="/hofstellen-verkaufen" element={<HofstellenPage />} />,
  <Route key="rinderstall-verkaufen" path="/rinderstall-verkaufen" element={<RinderstallVerkaufenPage />} />,
  <Route key="hof-mit-flaechen-verkaufen" path="/hof-mit-flaechen-verkaufen" element={<HofMitFlaechenPage />} />,
  <Route key="reitanlagen-verkaufen" path="/reitanlagen-verkaufen" element={<ReitanlagenVerkaufenPage />} />,
  <Route key="sonderkulturen-verkaufen" path="/sonderkulturen-verkaufen" element={<SonderkulturenVerkaufenPage />} />,
  <Route key="agrarflaechen-preise" path="/agrarflaechen-preise" element={<AgrarflaechenPreisePage />} />,
  <Route key="verkaufsprozess" path="/verkaufsprozess" element={<VerkaufsprozessPage />} />,
  <Route key="warum-agrarkapital" path="/warum-agrarkapital" element={<WarumAgrarKapitalPage />} />,
  <Route key="leistungen" path="/leistungen" element={<LeistungenPage />} />,
  <Route key="services" path="/services" element={<ServicesPage />} />,
  <Route key="unsere-leistungen" path="/unsere-leistungen" element={<ServicesPage />} />,
  <Route key="einzugsgebiet" path="/einzugsgebiet" element={<EinzugsgebietPage />} />,
  <Route key="wo-sind-wir-taetig" path="/wo-sind-wir-taetig" element={<EinzugsgebietPage />} />
];

export default contentRoutes;
